export default __webpack_public_path__ + "static/13-9-sitzer-1-d324ea53a7d8cdb9375141ff31f1ceb9.jpg";